
/* assets/int-gallery-axis.js — INT 2026-09-20, rewritten 2026-11-03 (Nils: "remove that lock ... like on
   Instagram its easy to scroll with thumb but still possible to swipe on carousels").
   WHAT CHANGED 2026-11-03. The pan-x lock in layout/theme.liquid (style#int-gallery-axis-touch) is gone, so a
   thumb on the picture scrolls the page again. The gallery is pan-y pinch-zoom: the BROWSER owns vertical
   scrolling and pinch, the CAROUSEL owns sideways swipes.
   HOW THE SWIPE STAYS CLEAN. Flickity listens for touchmove on WINDOW, and browsers make window touch listeners
   passive, so its preventDefault never stopped the page from drifting during a swipe (the old "it still scrolls
   down a bit when swiping"). This file binds its OWN touchmove on each gallery with passive:false and decides
   the direction on the first few pixels, the way Instagram does:
     sideways wins  -> preventDefault from that move on (page stays still) and Flickity drags at once
     downward wins  -> nothing is blocked, the page scrolls, Flickity is told not to drag
   Scoped to [data-product-slideshow] only; every other Flickity on the site behaves as before.
   Record: INTENTION_Shared/APPLIED-cart-lines-and-gallery-swipe-2026-11-03.md */
(function () {
  'use strict';

  var DEADZONE = 6;    /* px of travel before the direction is judged */
  var RATIO    = 1.15; /* sideways must beat downward by this much to be a swipe (about 41 degrees) */

  var g = null; /* the gesture in progress: { el, x, y, axis } */

  function galleryOf(t) {
    return t && t.closest ? t.closest('[data-product-slideshow]') : null;
  }

  function onStart(e) {
    var el = galleryOf(e.target);
    if (!el || !e.touches || e.touches.length !== 1) { if (g && g.el) g.el.__intAxis = 'y'; g = null; return; }
    g = { el: el, x: e.touches[0].clientX, y: e.touches[0].clientY, axis: null };
    el.__intAxis = null;
  }

  function onMove(e) {
    if (!g || e.currentTarget !== g.el) return;
    if (!e.touches || e.touches.length !== 1) { g.axis = 'y'; g.el.__intAxis = 'y'; return; } /* pinch: hands off */
    if (!g.axis) {
      var ax = Math.abs(e.touches[0].clientX - g.x);
      var ay = Math.abs(e.touches[0].clientY - g.y);
      if (ax < DEADZONE && ay < DEADZONE) return;
      g.axis = ax > ay * RATIO ? 'x' : 'y';
      g.el.__intAxis = g.axis;
    }
    if (g.axis === 'x' && e.cancelable) e.preventDefault();
  }

  function onEnd() { g = null; }

  function bind(el) {
    if (!el || el.__intAxisBound) return;
    el.__intAxisBound = true;
    el.addEventListener('touchmove', onMove, { passive: false });
  }

  function bindAll() {
    var list = document.querySelectorAll('[data-product-slideshow]');
    for (var i = 0; i < list.length; i++) bind(list[i]);
  }

  document.addEventListener('touchstart', onStart, { passive: true, capture: true });
  document.addEventListener('touchend', onEnd, { passive: true, capture: true });
  document.addEventListener('touchcancel', onEnd, { passive: true, capture: true });

  function isProductGallery(inst) {
    var el = inst && inst.element;
    return !!(el && el.hasAttribute && el.hasAttribute('data-product-slideshow'));
  }

  function install() {
    bindAll();
    var Flk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    if (!Flk || !Flk.prototype) return false;
    if (Flk.prototype.__intAxisLockPatched) return true;
    if (typeof Flk.prototype.pointerDown !== 'function') return false;
    if (typeof Flk.prototype.hasDragStarted !== 'function') return false;

    var origPointerDown    = Flk.prototype.pointerDown;
    var origHasDragStarted = Flk.prototype.hasDragStarted;

    Flk.prototype.pointerDown = function () {
      if (isProductGallery(this)) bind(this.element); /* a gallery built after load is bound for the next touch */
      return origPointerDown.apply(this, arguments);
    };

    Flk.prototype.hasDragStarted = function (moveVector) {
      if (!moveVector || !isProductGallery(this)) return origHasDragStarted.apply(this, arguments);
      var axis = this.element.__intAxis;
      if (axis === 'y') return false;   /* the page has this gesture */
      if (axis === 'x') return true;    /* a swipe: drag now, no extra threshold */
      /* no touch decision (mouse, pen): Flickity's own distance test, but only when clearly sideways */
      if (Math.abs(moveVector.x) < Math.abs(moveVector.y) * RATIO) return false;
      return origHasDragStarted.apply(this, arguments);
    };

    Flk.prototype.__intAxisLockPatched = true;
    return true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll);
  if (install()) return;
  var n = 0;
  var iv = setInterval(function () {
    n++;
    if (install() || n > 60) clearInterval(iv);
  }, 200);
})();
